import { HttpMethod } from "../components/Common/useFetch";
import { RequestOptions } from "../components/Common/useRequest";
import useUserRequest, { UserRequestSpec } from "../components/Common/useUserRequest";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";
import DriverDto from "../components/Common/dtos/DriverDto";

export type DriverUpsertDto = Omit<DriverDto, 'id'>;

const path = (businessId: string) => `/api/businesses/${businessId}/drivers`;

const createSpec = (businessId: string): UserRequestSpec => ({
  path: path(businessId),
  method: HttpMethod.POST,
});

const updateSpec = (businessId: string, driverId: string): UserRequestSpec => ({
  path: `${path(businessId)}/${driverId}`,
  method: HttpMethod.PUT,
});

const useUpsertDriver = (driverId?: string, options?: RequestOptions<string>) => {
  const business = useSelectedBusiness();

  var spec = driverId
    ? updateSpec(business.id, driverId)
    : createSpec(business.id);

  return useUserRequest<DriverUpsertDto, string>(spec, options);
}

export default useUpsertDriver;
